/*
 * Copyright 2025 ixPilot Teknoloji A.Ş. (ixpilot2021@gmail.com)
 * All rights reserved.
 *
 * This software is proprietary and confidential.
 * Unauthorized copying, modification, or distribution of this software,
 * via any medium, is strictly prohibited.
 *
 * Developed and maintained by ixPilot Teknoloji A.Ş.
 */

import { Box, Text, Flex } from "@chakra-ui/react";
import { getContextMenuPosition } from "utils/contextMenuPosition";

function StokContextMenu({
  position,
  data,
  onClose,
  onOpenNoteModal,
  onOpenEditModal,
  onDeleteStock,
  onMarkAsReady,
}) {
  if (!position) return null;
  const menuPosition = getContextMenuPosition(position, { menuWidth: 240, menuHeight: 240 });

  // Durumu raw olarak al (eğer durum bir React element ise, orijinal veriyi kullan)
  const currentStatus = data?.durum_raw || data?.durum;
  const canMarkAsReady =
    currentStatus === "ariza" || currentStatus === "arizali" || currentStatus === "arızalı";

  return (
    <Box
      position="fixed"
      top={`${menuPosition.y}px`}
      left={`${menuPosition.x}px`}
      bg="white"
      borderRadius="lg"
      shadow="0 4px 12px rgba(0, 0, 0, 0.15)"
      zIndex={2000}
      onMouseLeave={onClose}
      minW="140px"
      fontSize="11px"
      py={1}
    >
      {canMarkAsReady && (
        <MenuItem
          label="Hazır Yap"
          onClick={() => {
            onMarkAsReady?.(data);
            onClose?.();
          }}
        />
      )}
      <MenuItem
        label="Alış Tarihi / Tedarikçi Düzenle"
        onClick={() => {
          onOpenEditModal?.(data);
          onClose?.();
        }}
      />
      <MenuItem
        label="Not Ekle/Düzenle"
        onClick={() => {
          onOpenNoteModal?.(data);
          onClose?.();
        }}
      />
      <MenuItem
        label="Sil"
        isDestructive
        onClick={() => {
          onDeleteStock?.(data);
          onClose?.();
        }}
      />
    </Box>
  );
}

function MenuItem({ label, onClick, isDestructive = false }) {
  return (
    <Flex
      align="center"
      px={3}
      py={1.5}
      cursor="pointer"
      borderRadius="md"
      mx={1}
      transition="all 0.15s ease"
      _hover={{
        bg: isDestructive ? "red.50" : "gray.50",
        color: isDestructive ? "red.600" : "gray.900",
        transform: "scale(1.02)"
      }}
      onClick={onClick}
    >
      <Text 
        fontWeight="500" 
        color={isDestructive ? "red.500" : "gray.600"}
        fontSize="11px"
      >
        {label}
      </Text>
    </Flex>
  );
}

export default StokContextMenu;

